import React from 'react';
import styles from './ActionBar.module.css';
import ContentContainer from '../ContentContainer/ContentContainer';

export interface Action {
  key: string;
  type: 'primary' | 'secondary';
  buttonType: 'button' | 'submit' | 'reset';
  label: string;
}

interface ActionBarProps {
  actions: Action[];
  onAction: (actionKey: string) => void;
}

export const ActionBar: React.FC<ActionBarProps> = ({ actions, onAction }) => {
  return (
    <div className={styles.actionBar}>
      <ContentContainer>
        <div className={styles.actionsWrapper}>
          {actions.map(action => (
            <button
              key={action.key}
              className={`${styles.actionButton} ${styles[action.type]}`}
              type={action.buttonType}
              onClick={() => onAction(action.key)}
            >
              {action.label}
            </button>
          ))}
        </div>
      </ContentContainer>
    </div>
  );
};
